import React, { useContext, useEffect } from "react";
import { LoadingContainer } from "go-core/components/Loading";
import AttachmentsCard from "../../../../../../../../../../components/Attachment/AttachmentsCard";
import { PurchaseContext } from "../../pages/Preview";
import PurchaseBasicInfoCard from "../PurchasePreview/PurchaseBasicInfoCard";
import PurchaseItemsCard from "../PurchasePreview/PurchaseItemsCard/PurchaseItemsCard";
import PurchaseReceivesCard from "../PurchasePreview/PurchaseReceivesCard";

const PurchasePreviewTab = () => {
	const { purchase, setPurchase, purchaseReceives, fetchPurchaseReceives, fetchPurchase } =
		useContext(PurchaseContext);

	useEffect(() => {
		fetchPurchaseReceives();
	}, []);

	const handleUpdate = async () => {
		const promises = [fetchPurchase(), fetchPurchaseReceives()];
		await Promise.all(promises);
	};

	if (!purchaseReceives) return <LoadingContainer />;

	return (
		<div className="col px-0">
			{purchaseReceives.length > 0 && (
				<PurchaseReceivesCard receives={purchaseReceives} onHandleUpdate={handleUpdate} />
			)}
			<PurchaseBasicInfoCard purchase={purchase} onUpdate={setPurchase} />
			{purchase?.items?.length > 0 && <PurchaseItemsCard purchase={purchase} onUpdate={setPurchase} />}
			{purchase?.file_attachments?.length > 0 && <AttachmentsCard attachments={purchase.file_attachments} />}
		</div>
	);
};

export default PurchasePreviewTab;
